export const SYSTEM_BREADCRUMB_MUTATION_SET_LIST = 'system_breadcrumb_mutation_set_list'
export const SYSTEM_BREADCRUMB_MUTATION_ADD_ITEM = 'system_breadcrumb_mutation_add_item'

export const SYSTEM_BREADCRUMB_GETTER_GET_LIST = 'system_breadcrumb_getter_get_list'
